/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorissuedishwithoutname5Inputs */

const en_menueditorissuedishwithoutname5 = /** @type {(inputs: Menueditorissuedishwithoutname5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A dish has no name yet.`)
};

const de_menueditorissuedishwithoutname5 = /** @type {(inputs: Menueditorissuedishwithoutname5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Gericht hat noch keinen Namen.`)
};

/**
* | output |
* | --- |
* | "A dish has no name yet." |
*
* @param {Menueditorissuedishwithoutname5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorissuedishwithoutname5 = /** @type {((inputs?: Menueditorissuedishwithoutname5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorissuedishwithoutname5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorissuedishwithoutname5(inputs)
	return de_menueditorissuedishwithoutname5(inputs)
});
export { menueditorissuedishwithoutname5 as "menuEditorIssueDishWithoutName" }